import {
    apiRequest,
    PunishmentPegawaiList as list,
    kenaikanpangkaInactive,
    PromotionDeleteSKC,
    listunproccess,
    generate
} from "../../../../../services/adapters/kepegawaian/hukdisService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", list, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchGenerateTable = async (query, cancelToken) => {
        return await apiRequest("get", generate, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableunprocess = async (query, cancelToken) => {
        return await apiRequest("get", listunproccess, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
    fetchInactive = async (query) => {
        return await apiRequest("post", kenaikanpangkaInactive, {
            body: query
        }, true)
    }
    fetchInactiveSK = async (query) => {
        return await apiRequest("post", PromotionDeleteSKC, {
            body: query
        }, true)
    }
  

}

export default DataTableRepository